import { tv } from 'tailwind-variants';

const dividerStyles = tv({
  base: "iris:bg-(--comp-color-border-divider-default)",
  variants: {
    orientation: {
      horizontal: "iris:h-px iris:w-full",
      vertical: "iris:h-full iris:w-px"
    },
    inverse: {
      true: "iris:bg-(--comp-color-border-divider-inverse)",
      false: "iris:bg-(--comp-color-border-divider-default)"
    }
  },
  defaultVariants: {
    orientation: "horizontal",
    inverse: false,
    margin: "none"
  }
});

export { dividerStyles };
